export enum ROLE {
  ADMIN,
  FD_ADMIN,
  FD_USER,
}
